import React, { Suspense, lazy } from "react";
import "./index.css";

const domain = process.env.REACT_APP_DOMAIN;

// Lazy load footer components based on domain
const SwmcFooter = lazy(() => import("footer-component-swmc").then(module => ({ default: module.SwmcFooter })));
const CelligenceFooter = lazy(() => import("footer-component-celligence").then(module => ({ default: module.CelligenceFooter })));

const CustomFooter = () => {
  return (
    <Suspense fallback={<div>Loading footer...</div>}>
      {domain === "swmc" ? (
        <SwmcFooter type="swmc" showTacanewLogo={true} nydisclaimer={false} />
      ) : (
        <footer>
        <CelligenceFooter type="celligence" showTacanewLogo={true} nydisclaimer={false} />
        </footer>
      )}
    </Suspense>
  );
};

export default CustomFooter;
